import { lazy } from 'react';

// project-imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';


// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const UserList = Loadable(lazy(() => import('pages/users/users-list')));
const CreateUser = Loadable(lazy(() => import('pages/users/create-users')));
const AdminList = Loadable(lazy(() => import('pages/admins/admin-list')));
const CreateAdmin = Loadable(lazy(() => import('pages/admins/create-admin')));
const CreateCategory = Loadable(lazy(() => import('pages/category/create-category')));
const ManageCategory = Loadable(lazy(() => import('pages/category/category-list')));
const CreateReference = Loadable(lazy(() => import('pages/reference/create-reference')));
const ManageReference = Loadable(lazy(() => import('pages/reference/manage-reference')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
          <MainLayout />
      ),
      children: [
        {
          path: 'dashboard-page',
          element: <SamplePage />
        },
        {
          path: 'create-admin',
          element: <CreateAdmin />
        },
        {
          path: 'manage-admin',
          element: <AdminList />
        },
        {
          path: 'create-user',
          element: <CreateUser />
        },
        {
          path: 'manage-users',
          element: <UserList />
        },
        {
          path: 'create-category',
          element: <CreateCategory />
        },
        {
          path: 'manage-category',
          element: <ManageCategory />
        },
        {
          path: 'create-reference',
          element: <CreateReference />
        },
        {
          path: 'manage-reference',
          element: <ManageReference />
        },
       
      ]
    },
   
  ]
};

export default MainRoutes;
